import AgentActivity from 'models/agent_activity';
import changeCurrentLocation from 'actions/lib/change_current_location';
import GuidePerformanceView from 'models/location/guide_performance_view';
import PerformanceDateRange from 'models/performance_date_range';
import SetAndLogActivity from 'actions/agent_activity/set_and_log_activity';

export default class OpenGuidePerformance {
  constructor(context) {
    this.context = context;
  }

  run({ dateRange, guideCollectionId, interactionType, sort, pageNumber }) {
    const appFeatures = this.context.stores.appFeatures.get();
    if (!appFeatures.isEnabled('viewGuidePerformance')) {
      this.context.router.navigateHome();
      return;
    }

    if (!Object.values(PerformanceDateRange).includes(dateRange)) {
      this.context.router.navigateTo(
        GuidePerformanceView.create({
          dateRange: PerformanceDateRange.LAST_1_DAY,
          guideCollectionId,
          interactionType,
          sort,
          pageNumber,
        })
      );
      return;
    }

    changeCurrentLocation(
      this.context,
      GuidePerformanceView.create({ dateRange, guideCollectionId, interactionType, sort, pageNumber })
    );
    this.context.executeAction(SetAndLogActivity, { type: AgentActivity.Type.JOURNEYS });

    this.context.stores.guidePerformances.setLoading();
    this.context.gateways.guidePerformance.fetchAll({ dateRange, guideCollectionId, interactionType });
  }
}
